(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.mn-hdr').forEach((hdr) => {
    const burger = hdr.querySelector('.mn-burger');
    const panel = hdr.querySelector('#mn-mobile-panel');
    if (!burger || !panel) return;

    const toggle = (open) => {
      const isOpen = open ?? !panel.classList.contains('is-open');
      panel.classList.toggle('is-open', isOpen);
      panel.hidden = !isOpen;
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      burger.setAttribute('aria-label', isOpen ? 'Menü schließen' : 'Menü öffnen');
    };

    burger.addEventListener('click', () => toggle());

    // Panel schließen, wenn zurück auf Desktop-Breite
    window.matchMedia('(min-width: 1001px)').addEventListener('change', (e) => {
      if (e.matches) toggle(false);
    });

    // Header bei Runterscrollen ausblenden, bei Hochscrollen wieder zeigen
    const stickyEl = hdr.closest('.section-header') || hdr;
    let lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    let ticking = false;
    const topThreshold = 60; // ganz oben immer sichtbar
    const delta = 5;         // Totzone gegen Flackern

    const onScrollFrame = () => {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;

      // Bei geöffnetem Mobil-Menü Header sichtbar lassen
      if (panel.classList.contains('is-open') || y <= topThreshold) {
        stickyEl.classList.remove('mn-header--hidden');
      } else if (y > lastY + delta) {
        stickyEl.classList.add('mn-header--hidden');    // runter → ausblenden
      } else if (y < lastY - delta) {
        stickyEl.classList.remove('mn-header--hidden');  // hoch → einblenden
      }

      lastY = y;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(onScrollFrame);
        ticking = true;
      }
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
